import React from "react";
import globalMU from "globalMU";
import { RespostaConsultaItensOrcamento } from "app/types/orcamento/consultaItens/RespostaConsultaItensOrcamento";

const estilosConsultaitens = require('./consultaItens.module.scss').default;

export type RodapeConsultaItensProps = {
    dadosOrcamento: RespostaConsultaItensOrcamento
    numeroCasasDecimaisPreco: number
    /** Botão Fechar do rodapé. Sem o handler o botão não é renderizado. */
    onFechar?: () => void
}

/**
 * Totais + botão Fechar da consulta de itens. Componente separado de propósito: ele mora no
 * RODAPÉ do dialog (`DialogActions`), fora do `DialogContent`, para não rolar junto com a grade —
 * com muitos itens os totais saíam da vista e o Fechar ficava lá embaixo.
 */
export const RodapeConsultaItens = React.memo((props: RodapeConsultaItensProps) => {

    return (
        <div className={estilosConsultaitens.rodape}
            id="ConsultaItens_Rodape"
        >
            <div className={estilosConsultaitens.totais}
                id="ConsultaItens_Totais"
            >
                <span className={estilosConsultaitens.rotulo}
                    id="ConsultaItens_Totais_QuantidadeItens_Rotulo"
                >
                    Quantidade de Itens
                </span>
                <span className={estilosConsultaitens.valor}
                    id="ConsultaItens_Totais_QuantidadeItens_Valor"
                >
                    {props.dadosOrcamento.QuantidadeItens}
                </span>

                <span className={estilosConsultaitens.rotulo}
                    id="ConsultaItens_Totais_PesoTotal_Rotulo"
                >
                    Peso Total
                </span>

                <span className={estilosConsultaitens.valor}
                    id="ConsultaItens_Totais_PesoTotal_Valor"
                >
                    {globalMU.formatarValorNumerico(props.dadosOrcamento.PesoTotal, props.numeroCasasDecimaisPreco, false)}
                </span>

                <span className={estilosConsultaitens.rotulo} title="Veja parâmetro: Código para preço de custo"
                    id="ConsultaItens_Totais_Markup_Rotulo"
                >
                    Markup
                </span>
                <span className={estilosConsultaitens.valor}
                    id="ConsultaItens_Totais_Markup_Valor"
                >
                    {props.dadosOrcamento.MarkupRealTotal}
                </span>
            </div>

            {props.onFechar != null &&
                <button
                    id="ConsultaItens_BotaoFechar"
                    className={estilosConsultaitens.button}
                    onClick={props.onFechar}
                >
                    Fechar
                </button>
            }
        </div>
    );
});
